<template>
  <div class="w-full h-full flex items-center flex-col justify-center">
    <img
      class="absolute top-2 w-full h-16 object-contain z-10"
      v-if="!whitelabel"
      src="@/assets/gfx/fiasco-logo-white.png"
    />
    <div class="max-w-sm w-full flex flex-col p-4">
      <div class="intro-nav" v-if="!error">
        <form @submit.prevent="onSubmit()" class="login-form">
          <label class="text-white text-lg text-center w-full pl-4"> Dein Werkstatt-Code </label>
          <input
            class="text-gray px-4 text-lg w-full rounded-full mb-4 h-12"
            type="text"
            v-model="loginForm.inviteCode"
            autocomplete="off"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            placeholder="ABCDEF12"
          />
          <input
            type="submit"
            value="Anmelden"
            class="rounded-full w-full bg-fiasco-purple text-white text-lg mb-4 h-12 disabled:opacity-50"
            :disabled="!submitAvailable"
          />
        </form>
        <button
          class="w-full rounded-full border-2 border-white text-white text-lg mb-4 h-12"
          @click="goIntro()"
        >
          Abbrechen
        </button>
      </div>
      <div v-if="error" class="text-white text-lg">
        <div class="intro-retry-error my-4 text-center">
          <img class="w-12 block mx-auto" src="@/assets/gfx/icon-alert.png" />
          <div>{{ error }}</div>
        </div>
        <button
          class="rounded-full w-full bg-fiasco-purple text-white text-lg mb-4 h-12 disabled:opacity-50"
          @click="retry()"
        >
          Nochmal versuchen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Intro",
  data() {
    return {
      error: null,
      loginForm: {
        email: "",
        inviteCode: "",
      },
    }
  },
  methods: {
    goIntro() {
      this.$router.push({ name: "intro" })
    },
    goMain() {
      this.$router.push({ name: "main" })
    },
    retry() {
      this.error = false
      this.loginForm.inviteCode = ""
    },
    async onSubmit() {
      this.$store.commit("SET_BUSY", true)
      this.error = null

      try {
        await this.$store.dispatch("stations/getByCode", this.loginForm.inviteCode)
        this.$emit("login")

        if (this.customerStation) {
          console.log(this.customerStation)
          this.$store.commit("customers/TEMP_LOGIN")
          this.$emit("login")
        } else {
          this.error = "Keine Werkstatt für diesen Code gefunden."
        }

        this.$store.commit("error/SET_ERROR", false)
      } catch (err) {
        this.$store.commit("error/SET_ERROR", true)
        this.$store.commit("error/SET_ERROR_MESSAGE", err.message)
        this.$store.commit("error/SET_ERROR_CODE", err.status)
        this.$store.commit("SET_BUSY", false)
        throw new Error("Failed to get data from api", err)
      }

      this.$store.commit("SET_BUSY", false)
    },
  },
  computed: {
    submitAvailable() {
      return this.loginForm.inviteCode.length > 2
    },
    ...mapGetters({
      API: "API",
      busy: "busy",
      customer: "customers/customer",
      customerStation: "stations/customerStation",
      whitelabel: "whitelabel",
    }),
  },
  mounted() {
    console.log("REGI CODE MOUNTED")
  },
}
</script>
